import { render } from "./NursingTasks.vue?vue&type=template&id=f17bfbb6&ts=true"
import script from "./NursingTasks.vue?vue&type=script&lang=ts"
export * from "./NursingTasks.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__